import { apiAuth, apiResponseType } from ".";

interface LeftoverFilters {
  unity_id?: string;
  lottery_id?: string[];
  validation_start_date?: string;
  validation_end_date?: string;
}

export const getLeftoverProductsProcess = (page: number = 1, filters?: LeftoverFilters): apiResponseType => {
  let url = `leftover-products/process?page=${page}`;
  if (filters?.unity_id) {
    url += `&unity_id=${filters.unity_id}`;
  }
  if (filters?.lottery_id && filters.lottery_id.length > 0) {
    filters.lottery_id.forEach((id) => {
      url += `&lottery_id[]=${id}`;
    });
  }
  if (filters?.validation_start_date) {
    url += `&validation_start_date=${filters.validation_start_date}`;
  }
  if (filters?.validation_end_date) {
    url += `&validation_end_date=${filters.validation_end_date}`;
  }
  return apiAuth.get(url) as apiResponseType;
};

export const createLeftoverProductProcess = (data: FormData): apiResponseType => {
  return apiAuth.postForm("leftover-products/process/store", data) as apiResponseType;
};

export const showLeftoverProductProcess = (uuid: string): apiResponseType => {
  return apiAuth.get(`leftover-products/process/${uuid}/show`) as apiResponseType;
};

export const addFileToLeftoverProduct = (uuid: string, data: FormData): apiResponseType => {
  return apiAuth.postForm(`leftover-products/${uuid}/add-file`, data) as apiResponseType;
};

export const removeFileFromLeftoverProduct = (fileId: number): apiResponseType => {
  return apiAuth.delete(`leftover-products/file/${fileId}/remove`) as apiResponseType;
};

export const exportLeftoverProductProcess = (uuid: string): Promise<Blob> =>
  apiAuth
    .get(`leftover-products/process/${uuid}/export`, {
      responseType: "blob",
    })
    .then((response: any) => response.data);